import { deviceSystemTypeOptions, hvacOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"
import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"

import { FieldLabel, FieldsGrid, FieldWrapper, ReadOnlyValue } from "components/common/ModalFormFields"
import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"
import { SelectStatic } from "components/form/SelectStatic"

const systemAgeOptions: UITypes.Option[] = Array.from({ length: 30 }, (_, i) => ({
  value: (i + 1).toString(),
  label: `${i + 1} ${i + 1 === 1 ? "Year" : "Years"}`,
}))

interface Props {
  sn: string
  systemType: UITypes.Option[]
  installationType: UITypes.Option[]
  systemAge: UITypes.Option[]
  isPreInstallation?: boolean
  error: { field: string; message: string }
  onFieldChange: (field: string, value: UITypes.Option[]) => void
}

const SystemInformationSection = ({
  sn,
  systemType,
  installationType,
  systemAge,
  isPreInstallation = false,
  error,
  onFieldChange,
}: Props) => {
  return (
    <>
      <ModalSectionTitle title="System Information" Icon={IconDevice} />
      <FieldsGrid>
        <FieldWrapper>
          <FieldLabel>S/N</FieldLabel>
          <ReadOnlyValue>{sn}</ReadOnlyValue>
        </FieldWrapper>
        <FieldWrapper>
          <FieldLabel>System type</FieldLabel>
          {isPreInstallation ? (
            <SelectStatic
              placeholder="Select"
              values={systemType}
              options={deviceSystemTypeOptions}
              onChange={value => onFieldChange("systemType", value)}
              errorMessage={error.field === "systemType" ? error.message : ""}
            />
          ) : (
            <ReadOnlyValue>{systemType[0]?.label || "—"}</ReadOnlyValue>
          )}
        </FieldWrapper>
        <FieldWrapper>
          <FieldLabel>Installation Type</FieldLabel>
          <SelectStatic
            placeholder="Select"
            values={installationType}
            options={hvacOptions}
            onChange={value => onFieldChange("installationType", value)}
            errorMessage={error.field === "installationType" ? error.message : ""}
          />
        </FieldWrapper>
        <FieldWrapper>
          <FieldLabel>HVAC system age</FieldLabel>
          <SelectStatic
            placeholder="Select"
            values={systemAge}
            options={systemAgeOptions}
            onChange={value => onFieldChange("systemAge", value)}
            errorMessage={error.field === "systemAge" ? error.message : ""}
          />
        </FieldWrapper>
      </FieldsGrid>
    </>
  )
}

export { systemAgeOptions }
export default SystemInformationSection
